var React = require('react');

function AddInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.125 3.375H5.875V5.875H3.375V7.125H5.875V9.625H7.125V7.125H9.625V5.875H7.125V3.375ZM6.5 0.25C3.05 0.25 0.25 3.05 0.25 6.5C0.25 9.95 3.05 12.75 6.5 12.75C9.95 12.75 12.75 9.95 12.75 6.5C12.75 3.05 9.95 0.25 6.5 0.25ZM6.5 11.5C3.74375 11.5 1.5 9.25625 1.5 6.5C1.5 3.74375 3.74375 1.5 6.5 1.5C9.25625 1.5 11.5 3.74375 11.5 6.5C11.5 9.25625 9.25625 11.5 6.5 11.5Z","fill":"white"}));
}

AddInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = AddInline;

AddInline.default = AddInline;
